import { render, staticRenderFns } from "./AddButton.vue?vue&type=template&id=2f3be912&scoped=true&"
var script = {}
import style0 from "./AddButton.vue?vue&type=style&index=0&id=2f3be912&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3be912",
  null
  
)

export default component.exports